import axios from "@/axios";

export const namespaced = true

export const state = {
    lineChartLabels: [],
    lineChartOrders: [],
    mapChartOrders: [],
    barChartLabels: [],
    barChartLineItems: [],
    pieChartLabels: [],
    pieChartLineItems: [],
}

export const getters = {
    lineChartLabels: state => state.lineChartLabels,
    lineChartOrders: state => state.lineChartOrders,
    mapChartOrders: state => state.mapChartOrders,
    barChartLabels: state => state.barChartLabels,
    barChartLineItems: state => state.barChartLineItems,
    pieChartLabels: state => state.pieChartLabels,
    pieChartLineItems: state => state.pieChartLineItems,
}

export const mutations = {
    SET_LINE_CHART_LABELS: (state, response) => (state.lineChartLabels = response.data),
    SET_LINE_CHART_ORDERS: (state, response) => (state.lineChartOrders = response.data),
    SET_MAP_CHART_ORDERS: (state, response) => (state.mapChartOrders = response.data),
    SET_BAR_CHART_LABELS: (state, response) => (state.barChartLabels = response.data),
    SET_BAR_CHART_LINE_ITEMS: (state, response) => (state.barChartLineItems = response.data),
    SET_PIE_CHART_LABELS:  (state, response) => (state.pieChartLabels = response.data),
    SET_PIE_CHART_LINE_ITEMS:  (state, response) => (state.pieChartLineItems = response.data),
}

export const actions = {
    async getLineChartLabels({ commit }, id) {
        commit('SET_LINE_CHART_LABELS', await axios.get(`/api/insights/months`))
    },
    async getLineChartOrders({ commit }, filters) {
        return new Promise((resolve, reject) => {
            axios.post('/api/insights/linechartorder', filters, {config:{showToast: false}})
                .then((response) => {
                    commit('SET_LINE_CHART_ORDERS', response);
                    return resolve();
                })
                .catch((error) => {
                    return reject("There was an error saving the Report to the server..." + error.response.data);
                })
        });
    },
    async getMapChartOrders({ commit }, filters) {
        return new Promise((resolve, reject) => {
            axios.post('/api/insights/mapchartorder', filters, {config:{showToast: false}})
                .then((response) => {
                    commit('SET_MAP_CHART_ORDERS', response);
                    return resolve();
                })
                .catch((error) => {
                    return reject("There was an error saving the Report to the server..." + error.response.data);
                })
        });
    },
    async getBarChartLabels({ commit }, id) {
        commit('SET_BAR_CHART_LABELS', await axios.get(`/api/insights/orderstatuses`))
    },
    async getBarChartLineItems({ commit }, filters) {
        return new Promise((resolve, reject) => {
            axios.post('/api/insights/barchartlineitem', filters, {config:{showToast: false}})
                .then((response) => {
                    commit('SET_BAR_CHART_LINE_ITEMS', response);
                    return resolve();
                })
                .catch((error) => {
                    return reject("There was an error saving the Report to the server..." + error.response.data);
                })
        });
    },
    async getPieChartLabels({ commit }, id) {
        commit('SET_PIE_CHART_LABELS', await axios.get(`/api/insights/stockclasses`))
    },
    async getPieChartLineItems({ commit }, filters) {
        return new Promise((resolve, reject) => {
            axios.post('/api/insights/piechartlineitem', filters, {config:{showToast: false}})
                .then((response) => {
                    commit('SET_PIE_CHART_LINE_ITEMS', response);
                    return resolve();
                })
                .catch((error) => {
                    return reject("There was an error saving the Report to the server..." + error.response.data);
                })
        });
    },
    
    saveReport({ commit, state }) {
        
    }
}
